// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-cards[data-v-73dd7a30]{display:flex;justify-content:space-between;width:85%}@media(max-width:1000px){.global-cards[data-v-73dd7a30]{flex-direction:column;align-items:center;width:90%;padding-top:40px}}", ""]);
// Exports
module.exports = exports;
